import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Plug, Lightbulb, Wrench } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    number: '1',
    icon: <Zap className="text-blue-600" size={32} data-id="element-276" />,
    title: 'Blindaje y Seguridad',
    desc: 'Dominá tu cuadro eléctrico y trabajá con total seguridad desde el primer día.',
    bullets: ['Cómo leer e interpretar cualquier cuadro eléctrico doméstico', 'Protocolo de seguridad completo antes de tocar cualquier cable', 'Diagnóstico de averías básicas en menos de 10 minutos', 'Las 5 herramientas que necesitás y cómo usarlas']
  }, {
    number: '2',
    icon: <Plug className="text-blue-600" size={32} data-id="element-277" />,
    title: 'El Kit del Ahorro',
    desc: 'Enchufes, interruptores y conmutadores. El 70% de las llamadas al electricista son por esto. A partir de hoy, las resolvés vos.',
    bullets: ['Cambio de enchufes simples y schuko paso a paso', 'Instalación de interruptores y conmutadores sin errores', 'Cómo conectar correctamente sin dejar cables flojos', 'Verificación post-instalación con el comprobador']
  }, {
    number: '3',
    icon: <Lightbulb className="text-blue-600" size={32} data-id="element-278" />,
    title: 'Instalaciones Pro',
    desc: 'Lámparas, ventiladores, tiras LED y domótica básica. El nivel que te hace ver como un profesional.',
    bullets: ['Instalación de cualquier tipo de lámpara de techo', 'Montaje completo de ventiladores con luz y mando', 'Tiras LED: corte, conexión y controladores', 'Introducción a la domótica sin complicaciones']
  }, {
    number: '4',
    icon: <Wrench className="text-blue-600" size={32} data-id="element-279" />,
    title: 'El Manual del Oficio',
    desc: 'Diagnóstico avanzado y cómo convertir este conocimiento en ingresos extra reales.',
    bullets: ['Uso del multímetro para diagnóstico profesional', 'Diagnóstico avanzado de averías complejas', 'El kit completo de herramientas del oficio', 'Cómo cobrar por tus servicios y conseguir tus primeros clientes']
  }];
  return <section className="w-full bg-gray-50 py-20 px-4 border-t border-gray-200" data-id="element-280">
      <div className="max-w-5xl mx-auto" data-id="element-281">
        <div className="text-center mb-16" data-id="element-282">
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-283">
            Lo que obtenés
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mt-6 leading-tight" data-id="element-284">
            Los 4 Tomos de la Colección Completa
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-285">
          {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 relative overflow-hidden" data-id="element-286">
              <div className="absolute top-0 right-0 bg-blue-600 text-white px-4 py-1 rounded-bl-xl font-bold text-sm" data-id="element-287">
                Tomo {tomo.number} de 4
              </div>

              <div className="flex items-center gap-4 mb-6" data-id="element-288">
                <div className="bg-blue-50 p-3 rounded-xl" data-id="element-289">{tomo.icon}</div>
                <div data-id="element-290">
                  <div className="text-blue-600 font-bold text-sm uppercase tracking-wide mb-1" data-id="element-291">
                    TOMO {tomo.number}
                  </div>
                  <h3 className="text-2xl font-black text-gray-900" data-id="element-292">
                    {tomo.title}
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 font-medium mb-6 text-lg" data-id="element-293">
                {tomo.desc}
              </p>

              <ul className="space-y-3" data-id="element-294">
                {tomo.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-295">
                    <span className="text-yellow-500 shrink-0 mt-0.5" data-id="element-296">⚡</span>
                    <span className="text-gray-800 font-medium" data-id="element-297">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}